import { render, staticRenderFns } from "./ScrollWrapperV2.vue?vue&type=template&id=44df6edc&scoped=true&"
import script from "./ScrollWrapperV2.vue?vue&type=script&lang=js&"
export * from "./ScrollWrapperV2.vue?vue&type=script&lang=js&"
import style0 from "./ScrollWrapperV2.vue?vue&type=style&index=0&id=44df6edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df6edc",
  null
  
)

export default component.exports